exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n  max-width: 80%; }\n\n.modal-footer,\n.modal-body {\n  border-top: 1px solid #eceeef; }\n\n.modal-header {\n  padding: 10px 15px; }\n\n.modal-body {\n  padding: 25px 30px; }\n  .modal-body label {\n    font-size: 14px;\n    margin-bottom: 0;\n    padding-top: 8px;\n    width: 100%; }\n  .modal-body .button-block {\n    padding-top: 25px; }\n  .modal-body .content-block .row {\n    padding-top: 20px; }\n  .modal-body p {\n    white-space: pre-wrap; }\n  .modal-body .wrap-preline {\n    white-space: pre-line; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/modals/calendar/calendar-modal.scss
// module id = ../../../../../src/app/modals/calendar/calendar-modal.scss
// module chunks = main